import {
  localize as originalLocalize,
  setupLocalization as originalSetupLocalization,
  useLocalization as originalUseLocalization,
  LocalizationHook,
} from '@rw1/localization'
import {
  locales,
  LocalizationKey,
} from '@rw1/localization/locales/web-pages-launcher-ui'

export { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@rw1/localization'
export { SupportedLocale } from '@rw1/localization'
export type { LocalizationKey }

export const useLocalization = (): LocalizationHook<LocalizationKey> =>
  originalUseLocalization<LocalizationKey>()
export const setupLocalization = (): ReturnType<
  typeof originalSetupLocalization
> => originalSetupLocalization(locales)
export const localize = (key: LocalizationKey): string => originalLocalize(key)
